import { isEncryptedField } from '@/infra/crypto/payloads'
import type { DecryptFn } from '@/infra/sse/shared/decryption'
import { asRecordOrNull, processRawMetadata, tryDecryptRecord } from '@/infra/sse/shared/decryption'
import type { AgentActivityEventPayload } from '@/infra'
import type { RawActivityEventPayload } from './types'

export const processRawActivityEvent = async (
  raw: RawActivityEventPayload,
  decrypt: DecryptFn | null,
): Promise<AgentActivityEventPayload> => {
  const hookPayload = raw.rawHookPayload
  const keyVersion = raw.encryption?.keyVersion

  const toolName = typeof hookPayload['tool_name'] === 'string' ? hookPayload['tool_name'] : null

  const toolUseId =
    typeof hookPayload['tool_use_id'] === 'string' ? hookPayload['tool_use_id'] : null

  let toolInput: Record<string, unknown> | null = null
  const rawToolInput = hookPayload['tool_input']
  if (rawToolInput != null) {
    if (decrypt !== null && keyVersion !== undefined && isEncryptedField(rawToolInput)) {
      toolInput = await tryDecryptRecord(rawToolInput, keyVersion, decrypt)
    } else if (typeof rawToolInput === 'object' && !isEncryptedField(rawToolInput)) {
      toolInput = asRecordOrNull(rawToolInput)
    }
  }

  const metadata = await processRawMetadata(raw.eventMetadata, decrypt, keyVersion)

  return {
    toolName,
    toolInput,
    toolUseId,
    eventType: raw.eventType,
    eventMetadata: metadata,
    hostDetails: raw.hostDetails,
    telemetry: raw.telemetry,
  }
}
